import { Box, Typography, Grid } from "@mui/joy";

import { TextField, Textarea } from "../../../../../shared";

export default function ManufacturerConfiguration() {
    return (
        <Box flex={1}>
            <Box mt={2} display={"flex"} flexDirection={"column"} gap={1}>
                <TextField
                    name={"Name"}
                    label={"Manufacturer Name"}
                    helperText={"Enter the full name of the manufacturer"}
                    placeholder={"e.g., GAF Materials Corporation"}
                />
                <TextField
                    name={"ShortName"}
                    label={"Short Name"}
                    helperText={"Enter a short name or abbreviation"}
                    placeholder={"e.g., GAF"}
                />
                <Textarea
                    name={"Headquarters"}
                    label={"Headquarters"}
                    helperText={"Optional address of the headquarters"}
                    placeholder={"e.g., 1 GAF Drive, Parsippany, NJ 07054"}
                    minRows={3}
                />
                <Grid container spacing={2}>
                    <Grid xs={6}>
                        <TextField
                            name={"Founded"}
                            label={"Founded"}
                            helperText={"Optional year or date when the company was founded"}
                            placeholder={"e.g., 1886"}
                        />
                    </Grid>
                    <Grid xs={6}>
                        <TextField
                            name={"Industry"}
                            label={"Industry"}
                            helperText={"Optional industry sector"}
                            placeholder={"e.g., Roofing Materials"}
                        />
                    </Grid>
                </Grid>
                <TextField
                    name={"Website"}
                    label={"Website"}
                    helperText={"Optional company website URL"}
                    placeholder={"e.g., https://www.gaf.com"}
                />
                <TextField
                    name={"Status"}
                    label={"Status"}
                    helperText={"Manufacturer status (e.g., Active, Inactive)"}
                    placeholder={"e.g., Active"}
                />
            </Box>
        </Box>
    );
}
